import React from "react";

export const INPUT_STYLES =
  "w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none transition-all";
export const LABEL_STYLES = "block text-sm font-semibold text-gray-700 mb-2";

type TemplateMetadataFieldsProps = Readonly<{
  keywords: string;
  categorySlug: string;
  subcategorySlug: string;
  seoKeywords: string;
  onKeywordsChange: (value: string) => void;
  onCategorySlugChange: (value: string) => void;
  onSubcategorySlugChange: (value: string) => void;
  onSeoKeywordsChange: (value: string) => void;
}>;

export function TemplateMetadataFields({
  keywords,
  categorySlug,
  subcategorySlug,
  seoKeywords,
  onKeywordsChange,
  onCategorySlugChange,
  onSubcategorySlugChange,
  onSeoKeywordsChange,
}: TemplateMetadataFieldsProps) {
  return (
    <>
      <div>
        <label htmlFor="keywords" className={LABEL_STYLES}>
          Keywords (comma-separated) *
        </label>
        <input
          id="keywords"
          type="text"
          value={keywords}
          onChange={(e) => onKeywordsChange(e.target.value)}
          placeholder="e.g., design, creative, poster"
          className={INPUT_STYLES}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label htmlFor="categorySlug" className={LABEL_STYLES}>
            Category Slug *
          </label>
          <input
            id="categorySlug"
            type="text"
            value={categorySlug}
            onChange={(e) => onCategorySlugChange(e.target.value)}
            placeholder="Enter category slug"
            className={INPUT_STYLES}
          />
        </div>
        <div>
          <label htmlFor="subcategorySlug" className={LABEL_STYLES}>
            Subcategory Slug *
          </label>
          <input
            id="subcategorySlug"
            type="text"
            value={subcategorySlug}
            onChange={(e) => onSubcategorySlugChange(e.target.value)}
            placeholder="Enter subcategory slug"
            className={INPUT_STYLES}
          />
        </div>
      </div>

      <div>
        <label htmlFor="seoKeywords" className={LABEL_STYLES}>
          SEO Keywords (comma-separated) *
        </label>
        <textarea
          id="seoKeywords"
          rows={3}
          value={seoKeywords}
          onChange={(e) => onSeoKeywordsChange(e.target.value)}
          placeholder="e.g., marketing, branding, website"
          className={`${INPUT_STYLES} resize-none`}
        />
      </div>
    </>
  );
}
